import React, {useState} from 'react'
import './Modal.css'
import API from '../../../../Functions/API/api'


const Modal = ({showModal,setShowModal}) => {
     const [newUnit, setNewUnit] = useState({
    field: "Algebra",
    title: "",
    description: "",
    difficulty: "",
  });
    const handleChange = (e) => {
    setNewUnit({ ...newUnit, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
    const res = await API.post(
      `/unit`,  // unitId passed as prop or from URL
      newUnit
    );

     window.location.reload(); // reload the page
    }catch(err) {
        console.error("Error creating unit:", err.response?.data || err.message);
    throw err;
    }
    setShowModal(false);
   /*  fetchUnits(); // refresh list */
  };
  return (
    <div>
      {/* Modal */}
      {showModal && (
        <div className="ModalOverlay">
          <div className="ModalContent">
            <h2>Add New Unit</h2>
            <form onSubmit={handleSubmit}>
              <label>Field:</label>
              <select name="field" value={newUnit.field} onChange={handleChange}>
                <option value="Algebra">Algebra</option>
                <option value="Number Theory">Number Theory</option>
                <option value="Geometry">Geometry</option>
                <option value="Combinatorics">Combinatorics</option>
              </select>

              <label>Title:</label>
              <input
                type="text"
                name="title"
                value={newUnit.title}
                onChange={handleChange}
                required
              />

              <label>Description:</label>
              <textarea
                name="description"
                value={newUnit.description}
                onChange={handleChange}
                required
              />

              <label>Difficulty:</label>
              <select
                name="difficulty"
                value={newUnit.difficulty}
                onChange={handleChange}
                required
              >
                <option value=""disabled>Select difficulty</option>
                <option value="Easy">Easy</option>
                <option value="Medium">Medium</option>
                <option value="Hard">Hard</option>
              </select>

              <div className="ModalActions">
                <button type="submit">✅ Save</button>
                <button type="button" onClick={() => setShowModal(false)}>
                  ❌ Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}

export default Modal
